var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('spreadsheet-upload-error-table',{attrs:{"error":_vm.error}}),_c('our-validation-dialog',{attrs:{"state-error":_vm.error},model:{value:(_vm.showValidationDialog),callback:function ($$v) {_vm.showValidationDialog=$$v},expression:"showValidationDialog"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }